var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.366 22.6997C25.7464 22.6997 27.8153 20.564 27.8153 17.7831C27.8153 15.0356 25.7464 13 23.366 13C20.9855 13 18.9166 15.0801 18.9166 17.8053C18.9166 20.564 20.9744 22.6997 23.366 22.6997ZM16.3693 33H30.3404C32.0979 33 32.7208 32.4994 32.7208 31.5206C32.7208 28.6507 29.1279 24.6908 23.3548 24.6908C17.5929 24.6908 14 28.6507 14 31.5206C14 32.4994 14.6229 33 16.3693 33Z",
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatar);
export default __webpack_public_path__ + "static/media/icon-avatar.f48f89636aaa3e7eae7c7e31e020ca55.svg";
export { ForwardRef as ReactComponent };